import React from "react";
import { Toaster } from "sonner";
import { useIsMobile } from "@/shared/lib/hooks/useIsMobile";

const MAX_VISIBLE_TOASTS = 3;

export function AppToaster() {
    const isMobile = useIsMobile();

    return (
        <Toaster
            position={isMobile ? "top-center" : "bottom-right"}
            swipeDirections={isMobile ? ["top", "left", "right"] : ["right"]}
            visibleToasts={MAX_VISIBLE_TOASTS}
            gap={isMobile ? 8 : 12}
            offset={24}
            mobileOffset={{ top: "calc(env(safe-area-inset-top) + 12px)", left: 12, right: 12 }}
            containerAriaLabel="Notificações"
        />
    );
}
